<template lang="pug">
TestLayout(title="CreativeSizes")
  CreativeRow(v-if="creative != null" label="Size (px):")
    template(v-slot:content)
      CreativeSize(:creative="creative")
</template>

<script>
import { getNewCreativeOptions, newCreative } from '@helpers/Creative';

import TestLayout from '@root/src/apps/components/Global/TestLayout.vue';

import CreativeSize from '@master/UI/CreativeSize/CreativeSize.vue';

import CreativeRow from '@cm/Views/Creatives/Creative/CreativeRow.vue';

export default {
  name: 'CreativeSizesTest',

  components: {
    TestLayout,

    CreativeRow,
    CreativeSize,
  },

  data() {
    return {
      creative: null,
    };
  },

  async created() {
    this.creative = await newCreative(getNewCreativeOptions('infeed'));
  },
};
</script>
